"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsableItemList = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("report-home-collapsible");
var CollapsableItemList = function (_a) {
    var label = _a.label, icon = _a.icon, showSeparator = _a.showSeparator, children = _a.children;
    var _b = __read(react_1.default.useState(false), 2), expanded = _b[0], setExpanded = _b[1];
    var ExpandedIcon = expanded ? icons_1.ChevronUp : icons_1.ChevronDown;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: c("title"), onClick: function () { return setExpanded(!expanded); }, "aria-expanded": expanded },
            react_1.default.createElement("div", { className: c("label") },
                icon,
                react_1.default.createElement(kaleidoscope_1.Label, { align: "left", size: "m" }, label)),
            react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(ExpandedIcon, null) })),
        react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: expanded }, function (_a) {
            var expandableElementRef = _a.expandableElementRef;
            return (react_1.default.createElement("div", { className: c("content"), ref: expandableElementRef }, children));
        }),
        showSeparator && react_1.default.createElement(kaleidoscope_1.OptionMenuSeparator, null)));
};
exports.CollapsableItemList = CollapsableItemList;
